import { ERRORS } from 'src/app/components/exceptions/exceptions-screen/shared/entry-errors/entry-errors.constants';

export const EDIT_STOP_CONSTANTS = {
  ADD_WARNING_1: $localize`Please only perform one of these operation types at a time then save:`,
  ADD_WARNING_OPTION: $localize`     *Add,   *Delete,   *Edit,   *Complete`,
  ADD_WARNING_2: $localize`Multiple packages can be done but only one type of operation can be done before saving.`,
  ADD_WARNING_3: $localize`A fix to do operations normally will be coming soon.`,
  EDIT_STOP: $localize`Edit Stop`,
  ADDRESS_DETAILS: $localize`Address Details`,
  STOP_TYPE: $localize`Stop Type`,
  STOP_NUMBER: $localize`Stop No.`,
  CONSIGNEE: $localize`Consignee`,
  STREET_ADDRESS: $localize`Street Address`,
  CITY: $localize`City`,
  POSTAL: $localize`Postal Code`,
  PICKUP: $localize`Pickup`,
  DELIVERY: $localize`Delivery`,
  STOP_DATE: $localize`Stop Date`,
  PLAN_DATE: $localize`Plan Date`,
  DENSITY: $localize`Density`,
  NO_PKG_STATUS: $localize`No Pkg. Pickup Status`,
  PICKUP_REQUEST_NUMBER: $localize`Pickup Request #`,
  COMPLETE_TIME: $localize`Complete Time`,
  COMPLETE_TIME_PLACEHOLDER: '00:00',
  CURRENT_PACKAGES: $localize`CURRENT PACKAGES`,
  TRACKING_NUMBER: $localize`Tracking Number`,
  SHIPPER: $localize`Shipper`,
  SCAN_CODE: $localize`Scan Code`,
  OVERRIDE_SCAN_CODE: $localize`Scan Code`,
  REMARK_DESCRIPTION: $localize`Remark/Description`,
  CLARIFY: $localize`Clarify`,
  INFO_NOTICE: $localize`Info Notice`,
  AMOUNT_DUE: $localize`Amt Due`,
  AMOUNT_COLLECTED: $localize`Amt Collected`,
  ACTIONS: $localize`Actions`,
  ADD_PACKAGE: $localize`Add Package(s)`,
  OK: $localize`Ok`,
  COMPLETE_STOP: $localize`Complete Stop`,
  SAVE: $localize`Save`,
  STOP_TIME: $localize`Stop Time`,
  DATE_PLACEHOLDER: $localize`MM / DD / YYYY`,
  PAYMENT_TYPE: $localize`Payment Type`,
  CASH: $localize`CASH`,
  CHEQUE: $localize`CHEQUE`,
  TAXID_PFC: $localize`Tax ID/PFC?`,
  TAXID_PCF_NUMBER: $localize`Tax ID/PFC#`,
  VALIDATIONS: {
    REQUIRED: $localize`! Required`,
    INVALID_AMOUNT: $localize`! Amount Collected should be same as Amount Due`,
    INVALID_TRACKING_NUMBER: $localize`Invalid Tracking Number`,
    INVALID_SHIPPER: $localize`! Invalid Shipper`,
    REQUIRED_COD: $localize`! COD Required`,
    INTERCEPTED_PACKAGE_1: ERRORS.INTERCEPTED_TRACKING_NUMBER,
    INTERCEPTED_PACKAGE_2: ERRORS.RETURN_TO_CENTER,
    COD_GREATER_THAN_ZERO: $localize`! COD amount must be greater than 0.`,
    MIN_LENGTH: $localize`! Min character length: %s`,
    DUPLICATE_TRACKING_NUMBER: $localize`! Duplicate Tracking Number`,
  },

  DELETE_MODAL: {
    HEADER: $localize`Remove Tracking Number`,
    BODY: $localize`Removing the following Tracking Number from the stop will create a new stop:`,
    CONFIRM_BUTTON: $localize`Continue`,
    REJECT_BUTTON: $localize`Back`,
  },
  WARNING_MODAL_FOR_DELETE: {
    HEADER: $localize`Delete Package?`,
    BODY: $localize`Are you sure you want to delete this package?`,
    CONFIRM_BUTTON: $localize`Yes`,
    REJECT_BUTTON: $localize`No`,
  },
};

export const PLACEHOLDERS = {
  trackingNumber: $localize`Enter Tracking Number(s)`,
  amtDue: $localize`$000.00`,
  shipper: $localize`$000.00`,
  amtCollected: $localize`$000.00`,
  description: $localize`Enter Clarify/Description`,
  scanCode: $localize`Select Code`,
};

export const DENSITY_LIST = [
  {
    label: 'R - RESIDENTIAL',
    value: 'RESIDENTIAL',
  },
  {
    label: `C - COMMERCIAL`,
    value: 'COMMERCIAL',
  },
  {
    label: 'U - UNKNOWN',
    value: 'UNKNOWN',
  },
];

export const TAXID_PFC_LIST = [
  {
    label: 'TAXID',
    value: 'TAXID',
  },
  {
    label: 'PFC',
    value: 'PFC',
  },
];

export const SCAN_CODES = {
  DELIVERED: 'DELIVERED',
  CLOSED_ONE: 'CLOSED 1',
  CLOSED_TWO: 'CLOSED 2',
  CLOSED_THREE: 'CLOSED 3',
  CLSD_RETAIL: 'CLSD RETAIL',
  CONS_REFUSAL: 'CONS_REFUSAL',
  DELV_TO_RETL: 'DELV to RETL',
  SIG_OBTAINED: 'Sig Obtained',
  SCAN_CODE_EXCEPTION: 'SCAN CODE EX',
  KB: 'KB',
};

export const INFO_NOTICE_SCAN_CODES = [
  '51', // NO_MONEY_1
  'KZ', //NO_MONEY_2
  '52', //NO_MONEY_3
  'G3', //CLOSED_1
  'L1', //CLOSED_2
  'AY', //CLOSED_3
  'G7', //NO_ADULT_SIGNATURE_1
  'FM', //NO_ADULT_SIGNATURE_2
  'G8', //NO_ADULT_SIGNATURE_3
  '48', // NOT_IN_1
  'KX', //NOT_IN_2
  '49', //NOT_IN_3
];

export const SIG_OBTAINED_CODE = 'KB';

export const PICKUP_SCAN_CODE = '05';
